/* DigitalVesto - Satno azuriranje "urgency" brojeva (gledaoci, slobodna mesta, u korpi, prodato) */
(function(){
  'use strict';

  function hashStr(s){
    var h=0;
    for(var i=0;i<s.length;i++){h=(h<<5)-h+s.charCodeAt(i);h|=0;}
    return Math.abs(h);
  }
  function seededRandom(seed){
    var x=Math.sin(seed)*10000;
    return x-Math.floor(x);
  }
  function hourBucket(){
    return Math.floor(Date.now()/3600000); // menja se tacno svakog sata
  }
  function dayWaveFactor(){
    // 0..1 talas tokom 24h: nisko rano ujutru, visoko uvece, pa opet dole
    var d=new Date();
    var hourFloat=d.getHours()+d.getMinutes()/60;
    var rad=((hourFloat-6)/24)*2*Math.PI;
    return (Math.sin(rad-Math.PI/2)+1)/2;
  }
  function computeValue(el,idx){
    var min=parseInt(el.getAttribute('data-dv-min'),10);
    var max=parseInt(el.getAttribute('data-dv-max'),10);
    if(isNaN(min))min=0;
    if(isNaN(max)||max<=min)max=min+5;
    var seedBase=el.getAttribute('data-dv-seed')||el.id||('dv-'+idx);
    var bucket=hourBucket();
    var seed=hashStr(seedBase+':'+bucket);
    var rnd=seededRandom(seed);
    var wave=dayWaveFactor();
    var factor=(wave*0.6)+(rnd*0.4); // talas gore-dole + nasumicnost
    var val=Math.round(min+factor*(max-min));
    if(val<min)val=min;
    if(val>max)val=max;
    return val;
  }
  function updateAll(){
    var els=document.querySelectorAll('[data-dv-min][data-dv-max]');
    els.forEach(function(el,idx){
      el.textContent=computeValue(el,idx);
    });
  }

  function init(){
    updateAll();
    // proverava svakog minuta da li je poceo novi sat i tada osvezi brojeve
    var lastBucket=hourBucket();
    setInterval(function(){
      var b=hourBucket();
      if(b!==lastBucket){
        lastBucket=b;
        updateAll();
      }
    },60000);
  }

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);
  else init();
})();
